import Hero from '../components/Hero';
import BenefitsSection from '../components/BenefitsSection';
import TimelineSection from '../components/TimelineSection';
import CtaSection from '../components/CtaSection';
import RecentNews from '../components/RecentNews';

export default function HomePage() {
  return (
    <>
      <Hero />
      <BenefitsSection />
      <TimelineSection />
      <CtaSection />
      <RecentNews />
    </>
  );
}